import { Property } from '../../../views/CustomProperties/Properties/types';
import { PropertySet } from '../../../views/CustomProperties/PropertySets/types';
import { PropertySetsValues, PropertySetValues } from '../CustomProperties/types';

export type ListPropertyType = 'propertySet' | 'property';

export type ListProperty = {
  replacementKey: string;
  name: string;
  description: string;
  listType: ListPropertyType | '';
  elementId: number | undefined;
};

export const listPropertyDefaults: ListProperty = {
  replacementKey: '',
  name: '',
  description: '',
  listType: '',
  elementId: undefined,
};

export type ListType = {
  value: ListPropertyType;
  label: string;
};

export const LIST_TYPES: ListType[] = [
  { value: 'propertySet', label: 'Property Set' },
  { value: 'property', label: 'Property' },
];

export interface CreateListPropertyProps {
  onAdd: (listProperty: ListProperty) => void;
  alreadyAddedProperties: Property[];
  alreadyAddedPropertySets: PropertySet[];
}

export type CreateEntityGroupModalProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
} & CreateListPropertyProps;

export type ListPropertyProps = {
  path: string;
  listProperty: ListProperty;
  setListPropertySetValues: (propertySetsValues: PropertySetValues[]) => void;
  listPropertySetValues: PropertySetValues[]| [];
  propertySetsValues: PropertySetsValues;
  setPropertySetsValues: (propertySetsValues: {}) => void;
  isDisplayOnly?: boolean;
};

export type ListPropertyItemProps = {
  property?: Property | PropertySet;
  value: PropertySetValues;
}

export const isPropertySet = (property: Property | PropertySet): property is PropertySet => {
  return 'properties' in property;
}

export const isProperty = (property: Property | PropertySet): property is Property => {
  return 'type' in property;
}
